import React from 'react';
import { Navigate } from 'react-router-dom';
import { CheckCircle2Icon } from 'lucide-react';
import { useAssessment, useInstrumentConfig } from '../contexts/AssessmentContext';
export function Submitted() {
  const {
    submitted,
    sessionId,
    participantId
  } = useAssessment();
  const config = useInstrumentConfig();
  if (!submitted) return <Navigate to="/briefing" replace data-id="element-877" data-mp="1fm3p9tags94c" />;
  return <main className="flex w-full flex-1 items-center justify-center bg-slate-100 px-6 py-16" data-id="element-878" data-mp="23bek6u54v9ak">
      <div className="w-full max-w-xl rounded-xl border border-slate-200 bg-white p-8" data-id="element-879" data-mp="289zksuoaruzj">
        <CheckCircle2Icon className="h-7 w-7 text-teal-600" data-id="element-880" data-mp="1uagpj2gl4e4n" />
        <h1 className="mt-4 text-2xl font-semibold tracking-tight text-slate-900" data-id="element-881" data-mp="1u9yidasdwfhy">
          {config.id === 'LAW-001' ? 'Your review has been submitted' : 'Your close pack has been submitted'}
        </h1>
        <p className="mt-3 text-[15px] leading-relaxed text-slate-600" data-id="element-882" data-mp="ixny5srphrp4">
          Thank you — that is the end of the session. Nothing further is recorded from this point.
        </p>

        <dl className="mt-6 grid grid-cols-2 gap-4 rounded-lg border border-slate-200 bg-slate-50 p-5" data-id="element-883" data-mp="23az4pwuka3qb">
          <div data-id="element-884" data-mp="1ybwcxe3ldu0a">
            <dt className="text-[11px] font-semibold uppercase tracking-wider text-slate-500" data-id="element-885" data-mp="2d72jc26lnuu5">
              Session ID
            </dt>
            <dd className="mt-1 font-mono-num text-sm text-slate-900" data-id="element-886" data-mp="286xyjzynsdy4">{sessionId}</dd>
          </div>
          <div data-id="element-887" data-mp="2m6p9tsxsjg8f">
            <dt className="text-[11px] font-semibold uppercase tracking-wider text-slate-500" data-id="element-888" data-mp="2m660v1q4c26j">
              Participant
            </dt>
            <dd className="mt-1 font-mono-num text-sm text-slate-900" data-id="element-889" data-mp="2vxk7dtghm296">{participantId || '—'}</dd>
          </div>
        </dl>

        <div className="mt-6 space-y-3 text-[14px] leading-relaxed text-slate-600" data-id="element-890" data-mp="2qxxksterr9np">
          <p data-id="element-891" data-mp="34xyumyd0hrfb">Your record now goes to human review.</p>
          <p data-id="element-892" data-mp="34yrwbkx45qql">
            A written account of your performance is available on request — quote your session ID
            above.
          </p>
          <p data-id="element-893" data-mp="3803dt6a97vlp">
            Questions, corrections, or a request to withdraw your record:{' '}
            <a href="mailto:research@lentic.example" className="font-medium text-slate-900 underline underline-offset-2" data-id="element-894" data-mp="3cyxvg4whje48">
              research@lentic.example
            </a>
          </p>
        </div>
      </div>
    </main>;
}